import React from 'react';
import {IServiceFactory} from '../../services/service-factory.interface';
import {
    IModalDialogHandler,
    ShowModalOptions
} from '../../services/dialog/dialog.service.interface';
import {DialogConsumerContentBox} from './boxes/consumer-content/dialog-consumer-content.box';
import {DialogHeaderComponent} from './parts/header/dialog-header.component';
import {DialogOverlayBox} from './boxes/overlay/dialog-overlay.box';
import {DialogOverlayContentBox} from './boxes/overlay-content/dialog-overlay-content.box';
import {DialogIconWrapperBox} from './boxes/icon-wrapper/dialog-icon-wrapper.box';
import classNames from 'classnames';
import {
    APPLY_ANIMATION,
    APPLY_BORDERS, APPLY_MAX_HEIGHT,
    MOBILE_CENTERED_HEADER,
    DISABLE_FULLSCREEN_MOBILE,
    FORCE_CENTRALIZATION,
    FORCE_TRANSPARENT_BACKGROUND,
    FORCE_TRANSPARENT_CONTENT_BACKGROUND,
    FORCE_FULLSCREEN_TABLET, APPLY_MODAL_CLOSING_ANIMATION
} from './css-classes';
import {MODAL_DIALOG} from '../../themes/css-global-classes';
import {observer} from 'mobx-react';
import {CyClass} from "../../../common/cy-classes";
import {ThemeProvider} from "styled-components";

export interface ModalDialogComponentProps {
    services: IServiceFactory;
    dialogHandler: IModalDialogHandler;
    renderContent: (dialogHandler: IModalDialogHandler) => React.ReactNode;
    dialogOptions: ShowModalOptions;
}

export const ModalDialogComponent = observer(
    class ModalDialogComponent extends React.Component<ModalDialogComponentProps,{}> {


        private _onCloseButtonClickHandler = () => {
            this.props.dialogHandler.close(true, true);
        };

        render() {
            const overlayClasses = classNames(CyClass('cy-modal-dialog'), CyClass('cy-modal'), MODAL_DIALOG, {
                [FORCE_TRANSPARENT_BACKGROUND]: this.props.dialogOptions.forceTransparentBackground,
                [FORCE_CENTRALIZATION]: this.props.dialogOptions.forceCentralization,
                [DISABLE_FULLSCREEN_MOBILE]: this.props.dialogOptions.disableFullscreenMobile,
                [APPLY_ANIMATION]: this.props.dialogOptions.showOpenAndCloseAnimation,
                [FORCE_FULLSCREEN_TABLET]: this.props.dialogOptions.forceFullscreenTablet
            });

            const additionalHeaderClass = this.props.dialogOptions.headerClass || '';

            const headerClasses = classNames(CyClass('cy-modal-dialog-header'), CyClass('cy-modal-main-title'), additionalHeaderClass, {
                [MOBILE_CENTERED_HEADER]: this.props.dialogOptions.mobileCenterHeader
            });

            const contentClasses = classNames(CyClass('cy-modal-dialog-content'), {
                [APPLY_BORDERS]: !this.props.dialogOptions.hideBorders,
                [APPLY_ANIMATION]: this.props.dialogOptions.showOpenAndCloseAnimation,
                [DISABLE_FULLSCREEN_MOBILE]: this.props.dialogOptions.disableFullscreenMobile,
                [FORCE_TRANSPARENT_BACKGROUND]: this.props.dialogOptions.forceTransparentBackground,
                [FORCE_TRANSPARENT_CONTENT_BACKGROUND]: this.props.dialogOptions.forceTransparentContentBackground,
                [APPLY_MAX_HEIGHT]: this.props.dialogOptions.applyMaxHeight,
                [FORCE_FULLSCREEN_TABLET]: this.props.dialogOptions.forceFullscreenTablet,
                [APPLY_MODAL_CLOSING_ANIMATION]: this.props.dialogHandler.shouldApplyClosingAnimation
            });

            const dialogHeaderComponent = this.props.dialogOptions.hideDialogHeader ? (<></>) : (
                <DialogHeaderComponent
                    className={headerClasses}
                    title={this.props.dialogOptions.title}
                    hideCloseButton={this.props.dialogOptions.hideCloseButton}
                    onCloseButtonClick={this._onCloseButtonClickHandler}
                    renderExtraButtons={this.props.dialogOptions.renderExtraHeaderButtons}/>
                    );
            const transparentBackgroundOpacity = this.props.dialogOptions.transparentBackgroundOpacity || 0.80;
            const DialogIcon = this.props.dialogOptions.icon;

            return (
                <ThemeProvider theme={this.props.services.theme.popupsTheme}>
                    <DialogOverlayBox transparentBackgroundOpacity={transparentBackgroundOpacity}
                                      className={overlayClasses}
                                      isHidden={this.props.dialogHandler.isHidden}
                                      style={{zIndex: this.props.dialogHandler.zIndex}}>
                        <DialogOverlayContentBox className={contentClasses}>
                            {dialogHeaderComponent}
                            <DialogConsumerContentBox
                                useAutoHeight={this.props.dialogOptions.useAutoHeight}
                                overflow={this.props.dialogOptions.overflow}
                                className={classNames(CyClass('cy-modal-dialog-consumer-content'), CyClass('cy-modal-content'))}
                                noPadding={this.props.dialogOptions.noDefaultContentPadding}
                                disableFullscreenMobile={this.props.dialogOptions.disableFullscreenMobile}
                            >
                                {DialogIcon && <DialogIconWrapperBox>
                                    <DialogIcon style={{display: "inline"}} size={5.6}/>
                                </DialogIconWrapperBox>}
                                {this.props.renderContent(this.props.dialogHandler)}
                            </DialogConsumerContentBox>
                        </DialogOverlayContentBox>
                    </DialogOverlayBox>
                </ThemeProvider>
            );
        }
    }
);